import React from 'react';
import { Card, CardContent, Typography } from '@material-ui/core';
import './InfoBox.css';

const InfoBox = ({ title, cases, total, onClick, active, isRed }) => {
    return (
        <Card
            onClick={onClick}
            className={`infoBox ${active && 'infoBox--selected'} ${isRed && 'infoBox--red'}`}
        >
            <CardContent>
                <Typography className="infoBox_title" color="textSecondary">
                    {title}
                </Typography>
                <h2 className={`infoBox__cases ${!isRed && "infoBox__cases--green"}`}>{cases} Today</h2>
                <Typography className="infoBox__total" color="textSecondary">
                    {total} Total
                    </Typography>
            </CardContent>
        </Card>
    );
};

export default InfoBox